import {
  FETCH_AWARD,
} from './types';


export default {
  [FETCH_AWARD]: (state, payload) => {
    state.award = payload.award;
  },
};
